import signals from "signals";


export default class DeviceOrientation
{
    private _orientation: device_orientation_type = null;
    private _portraitMediaQueryList: MediaQueryList = null;

    private _onChanged: signals.Signal = null;


    public get orientation(): device_orientation_type { return /*this._orientation;*/device_orientation_type.PORTRAIT; }

    public get onChanged(): signals.Signal { return this._onChanged; }


    public constructor()
    {
        this._onChanged = new signals.Signal();

        /*this._portraitMediaQueryList = window.matchMedia( "(orientation: portrait)" );
        this._portraitMediaQueryList.addEventListener( "change", this._onPortraitMediaQueryList_Changed.bind( this ) );
   
        this._orientation = this._findOrientation();*/
    }

        private _findOrientation(): device_orientation_type
        {
            let result = null;

            if ( this._portraitMediaQueryList.matches ) 
            {
                result = device_orientation_type.PORTRAIT;
            } 
            else 
            {
                result = device_orientation_type.LANDSCAPE;
            }

            return result;
        }

        private _onPortraitMediaQueryList_Changed( mediaQueryList: MediaQueryList ): void
        {
            this._orientation = this._findOrientation();

            this._onChanged.dispatch( this._orientation );
        }
}

export const enum device_orientation_type
{
    PORTRAIT = 0,
    LANDSCAPE
}